import { Controller } from '@hotwired/stimulus';

import { SwiperOptions } from 'swiper';
import Swiper from 'swiper/bundle';
import 'swiper/css';

export default class extends Controller {
  static targets = ['subject'];

  static values = {
    options: Object,
  };

  connect() {
    this.swiper = new Swiper(this.subjectTarget, {
      ...this.defaultOptions,
      ...this.optionsValue,
    });
  }

  disconnect() {
    this.swiper.destroy();
    this.swiper = undefined;
  }

  get defaultOptions() {
    return {};
  }
}
